import { DateTime } from 'luxon'

import { Box, Comment as CommentBase, Text } from '@domain-group/suit-theme'

import type { CommentModel } from '@domain-group/realhub-backend-api-types'

import useComment from '@hooks/useComment'
import { useRelations as useUserRelations } from '@hooks/useUser'

const renderCommentBody = (comment: Partial<CommentModel>) => {
  const { body, data } = comment

  const templatePageId = data?.template_page_id
  if (templatePageId){
    return (
      <Box>
        <Text fontSize="xsmall">{body}</Text>
        <Text color="bodyFontLightColor" fontSize="xsmall" fontStyle="italic" marginLeft="small">
          from Template Page #{templatePageId}
        </Text>
      </Box>
    )
  }

  return body
}

interface CommentProps {
  comment: Partial<CommentModel>,
  hideLastChildBottomBorder?: boolean,
}

const Comment = (props: CommentProps) => {
  const { comment, hideLastChildBottomBorder } = props

  const commentPayload = useComment(comment)
  const { comment: { public: isPublic }, user } = commentPayload

  const { image } = useUserRelations(user)

  // @ts-expect-error
  const createdDateString = comment?.dates?.created?.date_time

  return (
    <CommentBase
      // @ts-expect-error TS2322
      commentBody={renderCommentBody(comment)}
      commentTime={
        createdDateString
          ? DateTime.fromFormat(createdDateString, 'dd/MM/yyyy HH:mm').toFormat("ccc, dd LLL yyyy 'at' h:mm a")
          : 'Not Set'
      }
      // @ts-expect-error TS2339
      fullName={user.full_name}
      hideLastChildBottomBorder={hideLastChildBottomBorder}
      // @ts-expect-error
      imageUrl={image.thumb_url}
      // @ts-expect-error TS2322
      isPublic={isPublic}
    />
  )
}

export default Comment
